module.exports = __webpack_public_path__ + "img/pensao-londres.a97abf5c.jpg";